<template>
    <div class="accordion" id="accordionExample">
        <div v-for="group in options" class="card">
            <div class="card-header" :class="{'bg-primary color-white-important': selectedCount(group) > 0 && !this.only_view}">
                <a href="javascript:void(0);"
                   class="card-title collapsed"
                   data-toggle="collapse"
                   aria-expanded="false"
                   v-bind:data-target="'#collapse'+group.id"
                   v-bind:aria-controls="'collapse'+group.id"
                >
                    {{ group.ua_name }} (Вибрано {{ selectedCount(group) }} з {{ group.cats.length }})
                    
                    <span class="ml-auto">
                            <span class="collapsed-reveal">
                                <i class="fal fa-minus-circle text-danger"></i>
                            </span>
                            <span class="collapsed-hidden">
                                <i class="fal fa-plus-circle text-success"></i>
                            </span>
                         </span>
                </a>
            </div>
            <div v-bind:id="'collapse'+group.id"
                 class="collapse"
                 aria-labelledby="headingOne"
                 data-parent="#accordionExample">
                <div class="card-body">
                    
                    <div v-for="tender in group.cats" class="cats_">
                        <div class="custom-control custom-checkbox">
                            <input
                                :disabled="only_view"
                                type="checkbox"
                                :checked="parseInt(tender.is_checked) === 1"
                                :key="tender.id + group.id"
                                :id="'cat'+tender.id + group.id"
                                :value="tender.id"
                                v-model="loc_subscribes"
                                class="custom-control-input"
                            />
                            <label class="custom-control-label" :for="'cat'+tender.id + group.id">
                                {{tender.ua_name}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    name: 'user_subscribe',
    
    props: {
        modelValue: {
            type: Array,
            default: () => []
        },
        selected : {
            type: Array,
            default: () => []
        },
        
        only_view : {
            type : Boolean,
            default : false,
        }
    },
    
    emits: ['update:modelValue'],
    
    created() {
        this.load_options();
    },
    
    data() {
        return {
            options: [
                {
                    ua_name: 'GR1',
                    id: 1,
                    cats: [
                        { ua_name: 'category1', id: 1 },
                        { ua_name: 'category2', id: 2 }
                    ]
                },
                {
                    ua_name: 'GR2',
                    id: 2,
                    cats: [
                        { ua_name: 'category3', id: 3 },
                        { ua_name: 'category4', id: 4 }
                    ]
                }
            ]
        };
    },
    
    computed: {
        
        loc_subscribes: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        },
        
    },
    
    methods: {
        
        selectedCount(group) {
            return  group.cats.filter(cat => !!cat.is_checked).length;
        },
        
        async load_options() {
            try {
                const { data } = await api.get('/tenders/general/subscribes');
                if (data.status === "operation_success") {
                    this.options = data.data
                        .map(group => {
                            group.cats = group.cats.map(cat => {
                                cat.is_checked = this.selected.includes(Number(cat.id)) ? 1 : 0;
                                return cat;
                            });
                            return group;
                        })
                        .filter(group => {
                            if (this.only_view) {
                                group.cats = group.cats.filter(c => c.is_checked);
                                return group.cats.length > 0;
                            }
                            return true;
                        });
                    
                   /* if(this.only_view) {
                        return this.options
                            .map(g => ({ ...g, cats: g.cats.filter(c => c.is_checked) }))
                            .filter(g => g.cats.length > 0)
                    }*/
                    
                    
                    this.$emit('update:modelValue', this.selected);
                }
            } catch (err) {
                EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
            }
        }
    },
    watch: {
        selected: {
            immediate: true,
            handler(val) {
                if (Array.isArray(val) && val.length > 0) {
                    this.load_options();
                }
            }
        }
    }
};
</script>